export default {

    popup(url, width, height) {

        var left = (window.screen.width / 2) - ((width / 2));
        var top = (window.screen.height / 2) - ((height / 2));

        window.open(url, '',
                "status=no,height=" + height + ",width=" + width + ",resizable=yes,left="
                + left + ",top=" + top + ",screenX=" + left + ",screenY="
                + top + ",toolbar=no,menubar=no,scrollbars=no,location=no,directories=no");


    }

}